import { useEscriptOnboardingContext } from '@/context/escript/EscriptOnboardingProvider';
import { Button, Dialog, DialogActions, DialogContent, Divider } from '@montugroup/design-system';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material';
import { EscriptOnboardingFlowContainer } from './EscriptOnboardingContainer';

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  background: theme.palette.common.white,
  padding: theme.spacing(6),
  minHeight: theme.spacing(75),
  alignContent: 'center',
}));

export const EscriptUploadModal = () => {
  const { showSubmitTokenModal, onboardingState, resetAndSubmitNewToken, toggleModal, submitToken, canSubmitToken } =
    useEscriptOnboardingContext();

  return (
    <Dialog
      open={showSubmitTokenModal}
      onClose={toggleModal}
      fullWidth
      maxWidth="md"
      TransitionProps={{
        onExited: () => {
          resetAndSubmitNewToken();
        },
      }}
    >
      <StyledDialogContent>
        <EscriptOnboardingFlowContainer />
      </StyledDialogContent>

      <Divider sx={(theme) => ({ margin: `0 ${theme.spacing(6)}` })} />
      <DialogActions
        sx={(theme) => ({
          padding: `${theme.spacing(6)} ${theme.spacing(4)}`,
          borderBottom: 1,
          borderColor: 'divider',
        })}
      >
        <Button onClick={toggleModal}>Cancel</Button>
        {onboardingState !== 'SUBMIT_TOKEN' ? (
          <Button onClick={resetAndSubmitNewToken} variant="outlined" color="primary" startIcon={<AddIcon />}>
            Add new token
          </Button>
        ) : (
          <Button
            data-testid="pharmacist-escript-submit"
            onClick={submitToken}
            disabled={!canSubmitToken}
            variant="contained"
            color="primary"
          >
            Submit token
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
